import { render, staticRenderFns } from "./SettingModal.vue?vue&type=template&id=01a8fa0c&"
import script from "./SettingModal.vue?vue&type=script&lang=js&"
export * from "./SettingModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports